import { useState } from "react";

function CookieSettings({ close }) {

  const [preferences, setPreferences] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  const saveSettings = () => {

    const settings = {
      necessary: true,
      preferences,
      analytics
    };

    localStorage.setItem("cookieConsent", JSON.stringify(settings));

    close();
  };

  return (

    <div style={{
      position: "fixed",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "9999"
    }}>

      <div style={{
        background: "white",
        padding: "25px",
        width: "400px",
        borderRadius: "10px"
      }}>

        <h3>Cookie Settings</h3>

        <label>
          <input type="checkbox" checked disabled />
          Necessary Cookies (Required)
        </label>

        <br/><br/>

        <label>
          <input
            type="checkbox"
            checked={preferences}
            onChange={() => setPreferences(!preferences)}
          />
          Preference Cookies
        </label>

        <br/><br/>

        <label>
          <input
            type="checkbox"
            checked={analytics}
            onChange={() => setAnalytics(!analytics)}
          />
          Analytics Cookies
        </label>

        <br/><br/>

        <button onClick={saveSettings}>
          Save Preferences
        </button>

        <button onClick={close} style={{ marginLeft: "10px" }}>
          Cancel
        </button>

      </div>

    </div>
  );
}

export default CookieSettings;